import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TimelineNav = /*#__PURE__*/function () {
  function TimelineNav(parent, progress) {
    var scrollWatchers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var links = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, TimelineNav);

    this.parent = parent;
    this.links = links;
    this.scrollWatchers = scrollWatchers;
    this.progress = progress;
    this.topScroll = 0;
    this.bottomScroll = 0;
    this.activeIndex = 0;
  }

  _createClass(TimelineNav, [{
    key: "updateProgress",
    value: function updateProgress() {
      if (window.scrollY > this.topScroll && window.scrollY < this.bottomScroll) {
        if (this.activeIndex === this.scrollWatchers.length - 1) {
          this.activeIndex = this.activeIndex - 1;
          this.parent.querySelector('.active').classList.remove('active');
          this.links[this.activeIndex].classList.add('active');
        }

        var activeItem = this.scrollWatchers[this.activeIndex];
        var siblingItem = this.scrollWatchers[this.activeIndex + 1];

        if (siblingItem) {
          var activeTop = activeItem.getBoundingClientRect().top + window.scrollY;
          var nextTop = siblingItem.getBoundingClientRect().top + window.scrollY;
          var mid = window.scrollY - activeTop;
          var max = nextTop - activeTop;
          var percentage = mid / max;

          if (percentage > 1) {
            this.parent.querySelector('.active').classList.remove('active');
            this.activeIndex = this.activeIndex + 1;
            this.links[this.activeIndex].classList.add('active');
          } else if (percentage < 0) {
            this.parent.querySelector('.active').classList.remove('active');
            this.activeIndex = this.activeIndex - 1;
            this.links[this.activeIndex].classList.add('active');
          }

          var scale = this.activeIndex / (this.scrollWatchers.length - 1) + percentage / this.scrollWatchers.length;
          this.progress.style.transform = "scaleX(".concat(scale, ")");
        }
      } else if (window.scrollY >= this.bottomScroll) {
        this.activeIndex = this.scrollWatchers.length - 1;
        this.progress.style.transform = "scaleX(1)";
        this.parent.querySelector('.active').classList.remove('active');
        this.links[this.activeIndex].classList.add('active');
      } else if (window.scrollY <= this.topScroll) {
        this.activeIndex = 0;
        this.progress.style.transform = "scaleX(0)";
        this.parent.querySelector('.active').classList.remove('active');
        this.links[this.activeIndex].classList.add('active');
      }
    }
  }, {
    key: "calculateScroll",
    value: function calculateScroll() {
      this.topScroll = this.scrollWatchers[0].getBoundingClientRect().top + window.scrollY;
      this.bottomScroll = this.scrollWatchers[this.scrollWatchers.length - 1].getBoundingClientRect().top + window.scrollY;
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      e.preventDefault();
      var element = e.target.nodeName === 'A' ? e.target : e.target.closest('a');
      var id = element.getAttribute('href').substring(1);
      var scrollTo = document.querySelector("#".concat(CSS.escape(id)));
      scrollTo.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, {
    key: "registerListeners",
    value: function registerListeners() {
      var _this = this;

      this.links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          return _this.onClick(e);
        });
      });
      window.addEventListener('scroll', function () {
        _this.updateProgress();
      }, {
        passive: true
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.calculateScroll();
      this.registerListeners();
    }
  }]);

  return TimelineNav;
}();

export { TimelineNav as default };